@if (isLoading()) {
  <div class="flex flex-col gap-4">
    <vx-skeleton class="h-28 w-full" />
    <vx-skeleton class="h-28 w-full" />
    <vx-skeleton class="h-28 w-full" />
  </div>
} @else {
  <div class="flex max-h-[60vh] flex-col gap-6 overflow-y-auto">
    @for (group of groups(); track $index) {
      <section class="flex flex-col gap-2">
        <h3 class="text-sm font-medium tracking-tight text-zinc-300">
          {{
            'pages.settings.alerting.processors.details.simulation.group'
              | transloco: { index: $index + 1 }
          }}
        </h3>
        <vx-panel variant="list">
          @for (alert of group.alerts; track alert.id) {
            <vx-list-row>
              <vx-item-cell
                icon="warning"
                [title]="alert.name"
                [subtitle]="alert.description" />
              <span vxRowActions>
                <app-alert-status-label [state]="alert.state" />
              </span>
            </vx-list-row>
          }
        </vx-panel>
      </section>
    } @empty {
      <vx-empty-state
        icon="siren"
        [title]="
          'pages.settings.alerting.processors.details.simulation.empty'
            | transloco
        " />
    }
  </div>
}
